<button
  mat-button
  *ngIf="item.type === 'button'"
  class="nav-link text-light"
  routerLink="{{ item.link }}"
  routerLinkActive="active"
>
  <mat-icon *ngIf="item.icon" class="nav-icon">{{ item.icon }}</mat-icon>
  <span>{{ item.nome }}</span>
</button>

<a
  mat-button
  *ngIf="item.type === 'link'"
  [href]="item.link"
  [target]="item.target"
  rel="noopener noreferrer"
  class="nav-link text-light"
>
  <mat-icon *ngIf="item.icon" class="nav-icon">{{ item.icon }}</mat-icon>
  <span>{{ item.nome }}</span>
</a>

<ng-container *ngIf="item.type === 'menu'">
  <button
    mat-button
    [matMenuTriggerFor]="menu"
    class="nav-link text-light pr-1"
  >
    <mat-icon *ngIf="item.icon" class="nav-icon">{{ item.icon }}</mat-icon>
    <span>{{ item.nome }}</span>
    <mat-icon class="drop-arrow">expand_more</mat-icon>
  </button>
  <mat-menu #menu>
    <ng-container *ngFor="let menuItem of item.menuItems">
      <button
        *ngIf="!menuItem.type"
        mat-menu-item
        routerLink="{{ menuItem.link }}"
        routerLinkActive="active"
        class="menu-item-btn"
      >
        <mat-icon *ngIf="menuItem.icon" class="menu-item-icon">{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.nome }}</span>
      </button>
      <a
        mat-menu-item
        *ngIf="menuItem.type === 'link'"
        [href]="menuItem.link"
        [target]="menuItem.target"
        rel="noopener noreferrer"
        class="nav-link menu-item-link"
        >
        <mat-icon *ngIf="menuItem.icon" class="menu-item-icon">{{ menuItem.icon }}</mat-icon>
        <span>{{ menuItem.nome }}</span>
      </a>
      <button
        mat-menu-item
        *ngIf="menuItem.type === 'dialog'"
        class="menu-item-btn"
        (click)="abrirDialog(menuItem)"
        class="nav-link menu-item-link"
      >
        <mat-icon *ngIf="menuItem.icon" class="menu-item-icon">
          {{ menuItem.icon }}
        </mat-icon>

        <span>{{ menuItem.nome }}</span>
      </button>
    </ng-container>
  </mat-menu>
</ng-container>

<div *ngIf="item.type === 'menuHover'" class="nav-dropdown">
  <button type="button" mat-button class="nav-link text-light nav-dropdown-trigger pr-1">
    <mat-icon *ngIf="item.icon" class="nav-icon">{{ item.icon }}</mat-icon>
    <span>{{ item.nome }}</span>
    <mat-icon class="drop-arrow">expand_more</mat-icon>
  </button>
  <div class="nav-dropdown-panel" role="menu">
    <a
      *ngFor="let menuItem of item.menuItems"
      class="nav-dropdown-item"
      routerLink="{{ menuItem.link }}"
      routerLinkActive="active"
      role="menuitem"
    >
      <mat-icon *ngIf="menuItem.icon" class="menu-item-icon">{{ menuItem.icon }}</mat-icon>
      <span>{{ menuItem.nome }}</span>
    </a>
  </div>
</div>
